import { render, staticRenderFns } from "./CommissioningModal.vue?vue&type=template&id=6b54deb2"
import script from "./CommissioningModal.vue?vue&type=script&lang=js"
export * from "./CommissioningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports